import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import { useNavigate, useLocation } from 'react-router-dom';
import { useStatus } from "../../Contexts/Context_Status_Global";
export default function UI_NavigationRail_Item({ Destination, Text, Icon, hasBadge, LoadingScreen }) {
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();
    const Location = useLocation();
    const { Slide_Switch, Slide_Active, Unsaved_Check } = useStatus();
    // const Navigate = async (Destination) => {
    //     if (await Unsaved_Check()) {
    //         if (LoadingScreen) {
    //             UI.Page_ChangePage(Destination, "Loading");
    //         } else {
    //             Slide_Switch(Destination);
    //         }
    //     }
        
    // }
    return (
        <>
            <button className='NavigationRail_Item' id={`Navigation_Button_${Destination}`} onClick={() => Navigate(`${Destination}`)} State={Location.pathname === Destination ? "Active" : "Inactive"}>
                <img className='NavigationRail_Item_Icon' src={Icon} draggable='false' loading='lazy' alt='' />
                <h4 className='NavigationRail_Item_Text'>
                    {Text}
                </h4>
                {hasBadge ? 
                    <div className="NavigationRail_Item_Badge">
                        
                    </div>
                    :
                    ""
                }
                
            </button>
        </>
    )
}

